import { type PreloadFetchPolicy } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type TeamProfileCardEntryPointQuery$variables,
} from './__generated__/TeamProfileCardEntryPointQuery.graphql';

const fetchPolicy: PreloadFetchPolicy = 'network-only';

const entryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_team-profile-card-entrypoint" */ './TeamProfileCardEntryPoint'
			),
		{
			moduleId: 'team-profile-card-entrypoint',
		},
	),
	getPreloadProps: ({ cloudId, teamId }: TeamProfileCardEntryPointQuery$variables) => ({
		queries: {
			queryRef: {
				parameters,
				variables: { cloudId, teamId },
				options: { fetchPolicy },
			},
		},
	}),
});

export { entryPoint };
